export const environment = {
	production: false,
	enableCache: true,
	demoApi: 'https://api-services.dev02.1placedessaisons.com/dev02/eakteplus-document-metadata-api/v1',
	idp: {
		issuer: 'https://api-services.int.1placedessaisons.com/int/v1/oidc',
		issuerV2: 'https://api-services.int.1placedessaisons.com/int/auth/v2/oidc',
		useV2Oidc: false,
		clientId: 'El2KSkYkCilLQsmXysk9eM5IoCMa',
	},

	firebase: {
		apiKey: "__FIREBASE_API_KEY__",
		authDomain: "eakteplusui-e99c3.firebaseapp.com",
		projectId: "eakteplusui-e99c3",
		storageBucket: "eakteplusui-e99c3.firebasestorage.app",
		messagingSenderId: "465908741861",
		appId: "1:465908741861:web:00324faf1cd3b4a185860c",
		measurementId: "G-KM2C24V7FT"

	},
};
